import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignTopContentCreatorsLoadAction } from '../../domains/campaignTopContentCreators/actions.types';

import { CampaignTopContentCreatorsLifecycle } from './types';

const initialState: CampaignTopContentCreatorsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<CampaignTopContentCreatorsLifecycle, CampaignTopContentCreatorsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'CAMPAIGN_TOP_CONTENT_CREATORS.LOAD_PENDING':
      return setPending();
    case 'CAMPAIGN_TOP_CONTENT_CREATORS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.campaignTopContentCreators);
    case 'CAMPAIGN_TOP_CONTENT_CREATORS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
